// ============================================================================
// post-client-mod -- Markdown 摘要工具
//
// 展示已改由后端渲染 contentHtml（写入时转换并净化），
// 前端不再需要运行任何 Markdown 转换（无 marked/dompurify 依赖）。
// 本文件仅保留列表页摘要用的纯文本提取函数。
// ============================================================================
/**
 * 从 Markdown 提取纯文本（去除标记语法），用于生成摘要。
 *
 * @param markdown - Markdown 源文本
 * @param maxLength - 最大长度，默认 160
 * @returns 截断后的纯文本摘要
 */
export function getMarkdownExcerpt(markdown, maxLength = 160) {
    if (!markdown)
        return '';
    const plainText = markdown
        .replace(/!\[[^\]]*\]\([^)]+\)/g, '')
        .replace(/\[([^\]]+)\]\([^)]+\)/g, '$1')
        .replace(/`{1,3}[^`]*`{1,3}/g, '')
        .replace(/#{1,6}\s+/g, '')
        .replace(/[*_~>-]+/g, '')
        .replace(/\n+/g, ' ')
        .trim();
    return plainText.length > maxLength
        ? plainText.slice(0, maxLength) + '...'
        : plainText;
}
//# sourceMappingURL=markdown.js.map